import { usePhoneActiveScreen } from '../../hooks/usePhoneActiveScreen'
import LayoutWrapper from '@/features/orders/components/Tabs/parts/LayoutWrapper'
import SearchTabsBar from '@/features/pos/components/Tabs/parts/SearchTabsBar'
import TopTabs from '@/features/ui/components/TopTabs'
import { Tab } from '@/features/ui/navigation'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Tabs: FC = () => {
    const { t } = useTranslation()

    const phoneScreen = usePhoneActiveScreen()

    const shouldHideTabs = phoneScreen === 'order-finalization'

    return (
        <TopTabs
            {...(shouldHideTabs
                ? { tabBar: () => null }
                : {
                      tabBar: (props) => (
                          <SearchTabsBar activeScreen={phoneScreen} topTabBarProps={props} />
                      ),
                  })}
            layout={({ children }) => <LayoutWrapper>{children}</LayoutWrapper>}
            screenOptions={{ swipeEnabled: false }}
        >
            <TopTabs.Screen
                name="(phone)"
                options={{
                    tabBarLabel: ({ focused }) => <Tab active={focused}>{t('phoneTabs.all')}</Tab>,
                }}
            />
        </TopTabs>
    )
}

export default Tabs
